"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Eula = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var cancelled_eula_1 = __importDefault(require("./cancelled-eula"));
var acceptable_eula_1 = __importDefault(require("./acceptable-eula"));
var defaultCancelEulaModalProps = {
    closable: false,
    forceSubmitOptions: {
        isForced: false,
        message: 'Returning to the login screen',
        time: 10
    },
    buttonText: ''
};
var Eula = function (props) {
    var isCancelled = props.isCancelled, onEulaCancel = props.onEulaCancel;
    if (!isCancelled) {
        return (0, jsx_runtime_1.jsx)(acceptable_eula_1["default"], __assign({}, props));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(cancelled_eula_1["default"], { onEulaCancel: onEulaCancel, modalProps: defaultCancelEulaModalProps }));
    }
};
exports.Eula = Eula;
Eula.displayName = 'Eula';
//# sourceMappingURL=eula.js.map